export default function Addresses(){return <div><h1 className="text-2xl font-black">Addresses</h1><p className="mt-2 text-slate-600">Manage shipping addresses.</p></div>;}
